import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { addTaskToNav, removeTaskToNav } from '../../store/app/addNavTask/AddNavTaskSlice';
import { fetchAllegati } from '../../store/app/allegati/AllegatiSlice';
import { fetchNote } from '../../store/app/diarioTrattazione/NoteSlice';
import { addIncaricato, fetchCauseIstruttoria, fetchCheckWorld, fetchIncarichiIstruttoria, fetchListaAllegatiPagamentoIndennizzo, fetchListaBeneficiariIndennizzo, fetchListaBenRecuperoFranchigiaTable, fetchListaDanneggiati, fetchListaDebitoreRecuperoRivalsa, fetchListaGaranzieDanneggiato, fetchListaGaranziePagamentoIndennizzo, fetchListaIncaricatoNoQuadro, fetchListaIncassiRecuperi, fetchListaIncassiRivalsa, fetchListaPagamenti, fetchRecuperoGaranzieRivalsa, fetchRiserveComplessive, fetchRiserveSpeseIncarico, fetchTicket, fetchTicketsLavorabili, fetchValidazioniIstruttoria, invalidateLavorabiliCompleti, markTicketListsDirty, refreshActiveTab, clearSearchLavorabiliCache, getDannegiatiCausa, getListaIncaricatoNoQuadro, getListaIncarichiCausa, getListaIncarichiSinistroCausa, removeIdTicketInCharge, removeOpenedTicket, setCheckWorldStatus, setEsitoSanzionePagamenti, setListaSoggettiCausa, setMotivazioneIncarico, setMotivazioneIncaricoNoQuadro, setRiservaSpesaIncarico, getCausaValidazioneApertura } from '../../store/app/ticket/TicketSlice';
import { removeTotalItemMessageToast } from '../../store/app/ws/WsSlice';
import { quotaRevoPerc } from '../../utils/coassicurazione';
import { fetchEmails } from '../../store/apps/email/EmailSlice';

import { EnabledDisabledStateTrueFalsePresaCarico /* toggleModaleSoggTerzoCollModifica */, setDisabledSelectEsiti, /* toggleModalMassimaleGaranzie, */ toggleModaleSoggTerzoColl } from '../../store/customizer/CustomizerSlice';


// Il component renderizza le informazioni nel toast
// e in funzione delle info ricevute dalla ws scatena 
// le operazioni di fetch
const ToastContent = (props) => {
    const dispatch = useDispatch();
    const requestIdFromProps = props.message;
    const navigate = Navigate
    const totalRequestMessageToast = useSelector((state) => state.wsReducer.itemMessagesToast);
    const soggetti = useSelector((state) => state.ticketReducer.openedTicket.datiCausa?.listaSoggetti?.content)
    const index = totalRequestMessageToast.findIndex((messageToast) => messageToast.requestId === JSON.parse(requestIdFromProps).requestId);
    const localToast = totalRequestMessageToast[index];
    const openedTicketLocal = (useSelector((state) => state.ticketReducer.openedTicket));
    const idSinistro = openedTicketLocal.datiDenuncia?.idSinistro;
    const modOpenedTicketsLocal = (useSelector((state) => state.ticketReducer.allOpenedTicket));
    const index2 = modOpenedTicketsLocal.findIndex((taskItem) => taskItem.datiTask.idTask === openedTicketLocal?.datiTask?.idTask?.toString());  
    // OSSQ-2386: quota in scala 0-100 per os-sinistri. Solo `index2` indicizza i ticket aperti:
    // `index` e' l'indice del messaggio toast, e usarlo qui leggeva la polizza sbagliata.
    const quotaPerc = quotaRevoPerc(modOpenedTicketsLocal[index2]?.datiPolizza?.coassicurazione)
    //const modalMassimaleGaranzie = useSelector((state) => state.customizer.isModalMassimaleGaranzieVisible);
    const taskIdInCharge = (useSelector((state) => state.ticketReducer.taskIdInCharge));
    const currentActiveTab = useSelector((state) => state.customizer?.currentActiveTab);
    const paginationLavorabili = useSelector((state) => state.ticketReducer?.paginationLavorabili);

    const sanitizePortalDetail = (message) => {
        if (!message) return '';
        const asString = String(message);
        const responseMessageMatch = asString.match(/responseMessages":\[(.*?)\]/);
        if (responseMessageMatch?.[1]) {
            const firstMessage = responseMessageMatch[1].match(/"([^"]+)"/);
            if (firstMessage?.[1]) return firstMessage[1];
        }
        return asString;
    };

    const buildManualSyncValidationDetail = (field) => {
        if (field === 'codTipoAttivita') {
            return 'Il fiduciario selezionato non è compatibile con il tipo perizia scelto.';
        }
        if (field === 'fiduciarioExternalId') {
            return "Il fiduciario selezionato non è allineato con l'anagrafica interna.";
        }
        if (field === 'portalEnabled') {
            return "L'incarico risulta già sincronizzato su Portal.";
        }
        return 'Dati incarico non completi per la sincronizzazione Portal.';
    };

    const formatPortalErrorForToast = (localErr) => {
        if (!localErr || !['EXT_PORTAL_API_ERROR', 'VAL_REQUIRED_FIELD'].includes(localErr?.code)) return null;

        const title = 'Sincronizzazione Portal non completata';

        if (localErr?.code === 'VAL_REQUIRED_FIELD') {
            return {
                title,
                detail: buildManualSyncValidationDetail(localErr?.details?.field),
            };
        }

        const motivazioni = localErr?.details?.motivazioni;
        if (Array.isArray(motivazioni) && motivazioni.length > 0 && motivazioni[0]) {
            return { title, detail: sanitizePortalDetail(motivazioni[0]) };
        }

        if (localErr?.message) {
            return { title, detail: sanitizePortalDetail(localErr.message) };
        }

        return { title, detail: 'Errore durante la sincronizzazione con Portal MSA.' };
    };

    const getToastDetailMessage = () => {
        const portalError = formatPortalErrorForToast(localToast?.localErr);
        if (portalError) return portalError;

        if (localToast?.localErr?.message) {
            return { title: null, detail: String(localToast.localErr.message) };
        }

        return { title: null, detail: '' };
    };
    
    // todo controllare local err nei file
    const handleAddTaskTab = (taskId) => {  
        //dispatch(fetchTicket( {taskId: localToast.taskId }));
        //dispatch(addTaskToNav({ taskId: localToast.taskId }));
        //dispatch(getCalcoloMassimali({}));
        //dispatch(fetchValidazioniIstruttoria(idSinistro));
        if(taskId !== null && taskId !== undefined && taskId !== "undefined") {
            dispatch(fetchTicket( {taskId}));
            dispatch(addTaskToNav({taskId}));
        }else {
            navigate('/home');
        }

        
    };

    const handleResult = () => {
        // CSP-3428: qualunque operazione andata a buon fine puo' aver cambiato
        // l'insieme dei task (coda, priorita', esito, presa in carico...).
        // Invece di un ramo dedicato per ogni entita' si segna il debito una
        // volta sola: le liste verranno rilette alla prossima apertura del tab,
        // senza chiamate extra se l'utente resta dov'e'. I rami che ricaricano
        // subito (esitazione, riassegnazione, nuovo task) continuano a farlo e
        // chiudono il debito appena la lettura va a buon fine.
        if (JSON.parse(requestIdFromProps)?.operation?.status === 'SUCCESS') {
            dispatch(markTicketListsDirty());
        }

        //here we process fecth if we need it
        if (localToast?.fetchToEval === "Allegati") dispatch(fetchAllegati(idSinistro));
        
        if (localToast?.fetchToEval === "Appuntamento")   dispatch(fetchNote(localToast.taskId));

        if (localToast?.fetchToEval === "Danneggiato"){
            //if (modalMassimaleGaranzie===true) dispatch(toggleModalMassimaleGaranzie());
            dispatch(fetchListaDanneggiati(idSinistro));
            dispatch(fetchListaGaranzieDanneggiato(localToast.taskId, localToast.danneggiatoId, localToast.ramoParams, localToast.idTitolo, localToast.idBene));
            dispatch(fetchRiserveComplessive(idSinistro,quotaPerc));
            dispatch(fetchEmails(localToast.taskId))
            //dispatch(toggleIsButtonEnabledMassimaleGaranzieVisible(true));
        }

        if(localToast?.fetchToEval === "SoggettoTerzo"){
            dispatch(fetchListaDanneggiati(idSinistro));
            dispatch(toggleModaleSoggTerzoColl());
        }

        if(localToast?.fetchToEval === "SoggettoTerzoModificato"){
            dispatch(fetchListaDanneggiati(idSinistro));
            // localToast.loading()
            //dispatch(toggleModaleSoggTerzoCollModifica());
        }

        if(localToast?.fetchToEval === "Soggetto_Terzo_Eliminato"){
            dispatch(fetchListaDanneggiati(idSinistro));
            if(localToast?.modalElimina === true) localToast.setModalElimina()
            if(localToast?.loading) localToast.loading()
            //dispatch(toggleModaleSoggTerzoCollModifica());
        }

        if (localToast?.fetchToEval === "DanneggiatoUpdate"){
            localToast.toggle()
            dispatch(fetchListaDanneggiati(idSinistro));
            dispatch(fetchListaGaranzieDanneggiato(localToast.taskId, localToast.danneggiatoId, localToast.ramoParams, localToast.idTitolo, localToast.idBene));
            dispatch(fetchRiserveComplessive(idSinistro,quotaPerc));
            dispatch(fetchNote(localToast.taskId));
            //dispatch(toggleIsButtonEnabledMassimaleGaranzieVisible(true));
        }
        
        if (localToast?.fetchToEval === "Email") dispatch(fetchEmails(openedTicketLocal?.datiTask?.idTask));

        if (localToast?.fetchToEval === "Diario"){
            dispatch(fetchNote(localToast.taskId));
            if(localToast.valToUpdateDescr && localToast.valToUpdateNota ) localToast.updateDescrNota(localToast.valToUpdateDescr,localToast.valToUpdateNota);
        }

        if (localToast?.fetchToEval === "Soggetto") dispatch(setListaSoggettiCausa(soggetti === null)) ;

        if (localToast?.fetchToEval === "Incaricato"){
            dispatch(fetchListaIncaricatoNoQuadro(localToast.incaricatoId));
            dispatch(addIncaricato(localToast.objIncaricato));
            dispatch(setMotivazioneIncarico(null));
            dispatch(setMotivazioneIncaricoNoQuadro(localToast?.motivazione));
            localToast.setDataFiduciarioNoQuadro([localToast.objIncaricatoLista]) 
        }
        
        if (localToast?.fetchToEval === "Incaricato_Modificato") {
            localToast.setDataFiduciarioNoQuadro([localToast.objIncaricato]);
            dispatch(fetchListaIncaricatoNoQuadro(localToast.incaricatoId));
            dispatch(setMotivazioneIncaricoNoQuadro(localToast?.motivazione));
        }

        if (localToast?.fetchToEval === "Incaricato_Eliminato") {
            localToast.setDataFiduciarioNoQuadro([])
            dispatch(getListaIncaricatoNoQuadro([]))
        };
            
        if (localToast?.fetchToEval === "RiservaSpese") {
            dispatch(fetchRiserveComplessive(localToast.sinistroId,quotaPerc));   
            dispatch(fetchRiserveSpeseIncarico(localToast.riservaSpesaId));
            dispatch(fetchValidazioniIstruttoria(localToast.sinistroId));
        }

        if( localToast?.fetchToEval === "BeSafeUpdate") {
            dispatch(fetchTicket({taskId: localToast.taskId}));
            }

        if (localToast?.fetchToEval === "RiservaSpeseUpdate") {
            dispatch(fetchRiserveComplessive(localToast.sinistroId,quotaPerc));   
            dispatch(fetchRiserveSpeseIncarico(localToast.riservaSpesaId));
            dispatch(fetchValidazioniIstruttoria(localToast.sinistroId));
            dispatch(setRiservaSpesaIncarico({importoRiserva : localToast.importoRiserva, riservaSpesaId: localToast.riservaSpesaId}))
            // CSP-3544: riserva variata dal task pagamento spese, ricarica gli incarichi del pagamento.
            if (localToast.pagamentoId) dispatch(fetchIncarichiIstruttoria(localToast.sinistroId, localToast.pagamentoId));
        }

        if (localToast?.fetchToEval === "RiservaSpeseUpdate") {
            dispatch(fetchRiserveComplessive(localToast.sinistroId,quotaPerc));   
            dispatch(fetchRiserveSpeseIncarico(localToast.riservaSpesaId));
            dispatch(fetchValidazioniIstruttoria(localToast.sinistroId));
            dispatch(setRiservaSpesaIncarico({importoRiserva : localToast.importoRiserva, riservaSpesaId: localToast.riservaSpesaId}))
            // CSP-3544: riserva variata dal task pagamento spese, ricarica gli incarichi del pagamento.
            if (localToast.pagamentoId) dispatch(fetchIncarichiIstruttoria(localToast.sinistroId, localToast.pagamentoId));
        }
        
		if (localToast?.fetchToEval === "Causa"){
		    dispatch(fetchCauseIstruttoria(localToast.idSinistro));
		}
        
        if (localToast?.fetchToEval === "Incarico"){
            dispatch(fetchIncarichiIstruttoria(localToast.idSinistro));
        }

        if (localToast?.fetchToEval === "PortalManualSync") {
            // Nessun refresh: il task è rimasto aperto, l'operatore riprova manualmente
        }

        if(localToast?.fetchToEval === "Fiduciario") {
            if(localToast.objPostCheckWorld !== undefined && localToast.objPostCheckWorld !== null && Object.keys(localToast.objPostCheckWorld).length > 0) dispatch(fetchCheckWorld(localToast.objPostCheckWorld));
            dispatch(fetchRiserveComplessive(localToast.idSinistroPagSpese,quotaPerc));
        }

        if(localToast?.fetchToEval === "Beneficiario") {
            dispatch(fetchListaBeneficiariIndennizzo(localToast.pagamentoId));
            if(localToast.objPostCheckWorld !== undefined && localToast.objPostCheckWorld !== null && Object.keys(localToast.objPostCheckWorld).length > 0) dispatch(fetchCheckWorld(localToast.objPostCheckWorld));
        }

        if(localToast?.fetchToEval === "BeneficiarioDelete") {
            dispatch(fetchListaBeneficiariIndennizzo(localToast.pagamentoId));
            dispatch(setCheckWorldStatus({checked: false, gridValues: [], status: '', dataEsecuzione: null}));
        }

        if(localToast?.fetchToEval === "Debitore") dispatch(fetchListaBenRecuperoFranchigiaTable(localToast.idRecupero));

        if(localToast?.fetchToEval === "debitoreRivalsa") dispatch(fetchListaDebitoreRecuperoRivalsa(localToast.rivalsaId));

        if(localToast?.fetchToEval === "garanzieRivalsa") dispatch(fetchRecuperoGaranzieRivalsa(localToast.rivalsaId));

        if(localToast?.fetchToEval === "incassiRivalsa") dispatch(fetchListaIncassiRivalsa(localToast.rivalsaId));

        if(localToast?.fetchToEval === "PagamentoSpesa"){
            dispatch(fetchListaPagamenti(localToast.idSinistroPagSpese));
            dispatch(fetchIncarichiIstruttoria(localToast.idSinistroPagSpese));
            dispatch(fetchRiserveComplessive(localToast.idSinistroPagSpese,quotaPerc))
        } 

        if(localToast?.fetchToEval === "PagamentoIndennizzo"){
            dispatch(fetchListaPagamenti(localToast.idSinistro));
            dispatch(fetchIncarichiIstruttoria(localToast.idSinistro));
            dispatch(fetchRiserveComplessive(localToast.idSinistro,quotaPerc))
        }
        if(localToast?.fetchToEval === "RiservaPagamentoIndennizzo"){
            dispatch(fetchListaGaranziePagamentoIndennizzo(localToast.valueSelect, localToast.pagamentoId));
        }

        if(localToast?.fetchToEval === "SanzioniConferma"){
            dispatch(setDisabledSelectEsiti(true));
            dispatch(fetchNote(localToast.taskId));
            dispatch(setEsitoSanzionePagamenti(localToast.esito));
        }

        if(localToast?.fetchToEval === "documentoGenerato") {
            dispatch(fetchListaAllegatiPagamentoIndennizzo(localToast.idSinistro, "QUIETANZA"))
            dispatch(fetchAllegati(localToast.idSinistro))
        } 

        if(localToast?.fetchToEval === "Esitazione"){
            dispatch(fetchValidazioniIstruttoria(localToast?.idSinistro));
            dispatch(fetchIncarichiIstruttoria(localToast?.idSinistro));
            dispatch(fetchRiserveComplessive(localToast.idSinistro,quotaPerc));
            // L'esitazione cambia l'insieme dei task lavorabili: la denuncia che
            // diventa sinistro passa al liquidatore e deve uscire da "tutti i task".
            // Senza questa invalidazione la riga resta a schermo perche' il lazy-load
            // per tab salta il fetch (listsLoaded.lavorabili gia' true) e il rientro in
            // griglia non ricarica nulla. Colpisce anche chi legge ticketsLavorabili
            // dallo store, es. Inventario Riserve.
            clearSearchLavorabiliCache();
            dispatch(invalidateLavorabiliCompleti());  // OSSQ-2383: anche la lista completa                     // ricerche filtrate: TTL 60s
            dispatch(refreshActiveTab(currentActiveTab));     // reset flag + refetch forzato
            //dispatch(setRiassegnaoperatoreSinistro(null));
            //dispatch(setOperatori(null));
        }

        if(localToast?.fetchToEval === "Riassegnazione sinistro"){
            const taskId = localToast?.taskId;

            dispatch(removeTaskToNav({ taskId }));
            dispatch(removeIdTicketInCharge(taskId)); //free frontend
            if (taskIdInCharge === `${taskId};`) {
                //se esistono altri ticket in modalitÃ  di modifica occorre lasciare invariato lo stato del customizer
                //diversamente andiamo in toggle
                dispatch(EnabledDisabledStateTrueFalsePresaCarico());
            }
            dispatch(removeOpenedTicket({ taskId })); //TicketReducer
            // Come l'esitazione: riassegnando il sinistro il task passa a un altro
            // liquidatore ed esce dai lavorabili visibili, quindi le liste di griglia
            // vanno invalidate o la riga resta a schermo (il lazy-load per tab non
            // ricarica: listsLoaded.lavorabili e' gia' true).
            clearSearchLavorabiliCache();
            dispatch(invalidateLavorabiliCompleti());  // OSSQ-2383: anche la lista completa
            dispatch(refreshActiveTab(currentActiveTab));
        }

        if(localToast?.fetchToEval === "AddIncassoRecupero"){
            dispatch(fetchListaIncassiRecuperi(localToast?.idRecupero));
        }

        if(localToast?.fetchToEval === "NuovoTask") {
            // La lista lavorabili e' paginata server-side: senza page/size questa
            // chiamata finisce sull'endpoint non paginato e lascia paginationLavorabili
            // invariata, quindi griglia e paginatore vanno fuori sincrono. Si ricarica
            // la pagina corrente e si svuota la cache delle ricerche (TTL 60s), perche'
            // un task nuovo cambia l'insieme dei lavorabili.
            clearSearchLavorabiliCache();
            dispatch(invalidateLavorabiliCompleti());  // OSSQ-2383: anche la lista completa
            dispatch(fetchTicketsLavorabili(paginationLavorabili?.page ?? 0, paginationLavorabili?.size ?? 50));
        }

        if(localToast?.fetchToEval === "UpdateRiserva"){
            dispatch(fetchListaGaranziePagamentoIndennizzo(localToast?.valueSelect, localToast?.pagamentoId));
            // Il fallback copre i toast gia' in coda al momento del rilascio, il cui payload non
            // ha ancora `quotaPerc`: e' comunque la quota della stessa polizza.
            dispatch(fetchRiserveComplessive(localToast?.idSinistro,localToast?.quotaPerc ?? quotaPerc));
        }

        if(localToast?.fetchToEval === 'Danneggiatocausa') {
            dispatch(getDannegiatiCausa(localToast?.idCausa))
            dispatch(getListaIncarichiCausa(localToast?.idCausa))
            dispatch(getListaIncarichiSinistroCausa(localToast?.idSinistro, localToast?.idCausa))
            dispatch(getCausaValidazioneApertura(localToast?.idCausa))
        }
        if(localToast?.fetchToEval === 'IncaricatoCausa') {
            dispatch(getListaIncarichiCausa(localToast?.idCausa))
            dispatch(getListaIncarichiSinistroCausa(localToast?.idSinistro, localToast?.idCausa));
            dispatch(getCausaValidazioneApertura(localToast?.idCausa))
        }
        //last but not least
        if (localToast?.loader) localToast.loader();
    }

    useEffect(() => {
        let  timeout = 2000;
        if (localToast?.navigate && JSON.parse(requestIdFromProps).operation.status!=='SUCCESS') timeout = 1500;
        
        handleResult();
        /*
        setTimeout(() => {
            dispatch(removeTotalItemMessageToast(localToast?.requestId));            
            //if (localToast?.fetchToEval === "Esitazione" && localToast.idTaskPadre !== undefined && localToast.idTaskPadre !== "") handleAddTaskTabFiglioToPadre(localToast?.idTaskPadre)
            let idLink = localToast?.taskId;
            if (localToast?.idTaskPadre !== undefined && localToast?.idTaskPadre !== "" && localToast?.navigate && localToast?.navigate2father) {
                //&& localToast?.navigate2father
                // eslint-disable-next-line eqeqeq  
                if (idLink != localToast?.idTaskPadre) {
                    idLink = localToast?.idTaskPadre;
                } else {
                    
                    localNavigate = false; 
                }
            } //else localNavigate = false;
            if (localToast?.navigate && localNavigate && !(localToast?.idTaskPadre === undefined || localToast?.idTaskPadre === "")) document.getElementById(idLink).click();
        }, timeout);*/

        //CArnoutMAP
        //localToast?.idTaskPadre !== undefined && localToast?.idTaskPadre !== "" >> Ã¨ un task figlio
        //localToast?.navigate true && localToast?.navigate2father false==> Ã¨ una creazione task ==> navighiamo su quel task
        //localToast?.navigate true && localToast?.navigate2father true ==> Ã¨ sicureamente un esitazione ==> navighiamo sul padre
        let localNavigate = true; //to avoid the effect task reload on itself
        setTimeout(() => {    
       
            let idLink = 'child';//localToast?.taskId;  //we are working on this link
            if (localToast?.idTaskPadre !== undefined && localToast?.idTaskPadre !== "" && localToast?.navigate && localToast?.navigate2father ) {
                //if you came from an esitazione then u can go to father
                //idLink = localToast?.idTaskPadre; 
                idLink= 'father';
                //if you are here u are closing task and u are going to father
            } else if (localToast?.navigate && localToast?.navigate2father) { 
                //siamo in esitazione di un task padre, scegliamo di non visualizzarlo
                localNavigate=false;
            } 
            // determina se esiste un task in carico al FE
        
            //go to link selected new child or father
            if (localToast?.navigate && localNavigate && document.getElementById(idLink)!==null && ((localToast.idTaskPadre !== null && localToast.idTaskPadre !== undefined) || ( localToast.taskId !== null && localToast.taskId !== undefined)))/*&& !(taskIdInCharge.toString().includes(idLink)))*/
                document.getElementById(idLink).click();
            if (JSON.parse(requestIdFromProps).operation.status==='SUCCESS')
                dispatch(removeTotalItemMessageToast(localToast?.requestId));
        }, timeout);
            
    }, [props]);

    const toastError = getToastDetailMessage();

    return (   
        <>
            {index !== -1 ? (
                <><h5 className="fw-bold">
                Aggiornamento: <span className="text-lowercase">{localToast?.entityName}</span>
            </h5>
            <p>
            {`${JSON.parse(requestIdFromProps).operation.status}`}
            {toastError?.title ? ` - ${toastError.title}` : null}
            </p>
            {toastError?.detail ? <p className="mb-2">{toastError.detail}</p> : null}
            {
                (localToast?.idTaskPadre !== undefined && localToast?.idTaskPadre !== "" && localToast?.navigate && localToast?.navigate2father)  ?
                <Link id='father'  to={`/task/${localToast?.idTaskPadre}`}  onClick={() => handleAddTaskTab(localToast?.idTaskPadre)} className="btn btn-primary btn-sm">
                 Task:{localToast?.idTaskPadre}
                </Link> :
                 <Link id='child'  to={`/task/${localToast?.taskId}`}  onClick={() => handleAddTaskTab(localToast?.taskId)} className="btn btn-primary btn-sm">
                 Task:{localToast?.taskId}
             </Link> 


            }

            {/* <Link id={localToast?.taskId}  to={/task-${localToast?.taskId}}  onClick={handleAddTaskTab} className="btn btn-primary btn-sm">
                Task:_{localToast?.taskId}
            </Link> a  */}

            <br/></>) : <></>}
        </>
    )
  }
  
  export default ToastContent;
  
